export default "__VITE_ASSET__DWtRxAaZ__"